import {
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";

function TldrInputWithAddon(props) {
  const [value, setValue] = useState(props.value ? props.value : "");

  useEffect(() => {
    setValue(props.value);
  }, [props.value]);

  const handleOnChange = (text) => {
    setValue(text);
    if (typeof props.onChange === "function") {
      props.onChange(text);
    }
  };

  const handleOnFocus = (text) => {
    setValue(text);
    if (typeof props.onFocus === "function") {
      props.onFocus(text);
    }
  };

  const handleOnBlur = (text) => {
    setValue(text);
    if (typeof props.onBlur === "function") {
      props.onBlur(text);
    }
  };

  const handleKeyUp = (e) => {
    if (typeof props.onKeyUp === "function") {
      props.onKeyUp(e);
    }
  };

  return (
    <InputGroup w="inherit">
      {props.addonLeftChildren && (
        <InputLeftElement children={props.addonLeftChildren} />
      )}
      <Input
        borderRightRadius={props.borderRightRadius}
        value={value}
        onChange={(e) => handleOnChange(e.target.value)}
        onFocus={(e) => handleOnFocus(e.target.value)}
        onBlur={(e) => handleOnBlur(e.target.value)}
        onKeyUp={handleKeyUp}
        maxLength={props.maxLength}
        placeholder={props.placeholder ? props.placeholder : ""}
        maxW={props.maxW ?? "100%"}
        sx={props.searchInputSx}
      />
      {props.addonRightChildren && (
        <InputRightElement children={props.addonRightChildren} />
      )}
    </InputGroup>
  );
}

export default TldrInputWithAddon;
